import { render, staticRenderFns } from "./transfer-product.vue?vue&type=template&id=8e86d678&"
import script from "./transfer-product.vue?vue&type=script&lang=tsx&"
export * from "./transfer-product.vue?vue&type=script&lang=tsx&"
import style0 from "./transfer-product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports